import {
  CtrlBaseSuggestionArgs,
  SelectedFiltersVector,
  TechnicalSelection,
} from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "@src/core/engine/helpers/withDelete";
import { buildEngineSelectedFilters } from "../../helpers/buildEngineSelectedFilters";
import { FilterGroupsState } from "../../technicalSelectionRepository";

export type ActuatorSelectionArgsOptions = {
  productId: string;
  subProductFilters: FilterGroupsState;
  subProductType: "actuators";
};

export function initActuatorsSuggestionArgs(
  technicalSelection: TechnicalSelection,
  currentSelection: SelectedFiltersVector,
  suggestionArgs: CtrlBaseSuggestionArgs,
  options: ActuatorSelectionArgsOptions,
) {
  const actuatorsFiltersEngine = buildEngineSelectedFilters(
    options.subProductFilters,
  );
  const actuatorsFilterGroups = withDelete(
    [actuatorsFiltersEngine],
    technicalSelection.getActuatorsFilters(
      options.productId,
      currentSelection,
      actuatorsFiltersEngine,
    ),
  );
  suggestionArgs.saveActuatorsFilters(actuatorsFilterGroups);
}
